import React from 'react';
import PropTypes from 'prop-types';

const Page = props => (
  <div className="vf-page">
    {props.children}
  </div>
);

Page.propTypes = {
  children: PropTypes.node.isRequired,
};

Page.displayName = 'Page';

export default Page;
